import React from 'react'
import HowWeWorkHero from './sections/HowWeWorkHero.js'
import HowWeWorkPhase from './sections/HowWeWorkPhase.js'

const HowWeWork = () => {
  return (
    <>
    <HowWeWorkHero/>
    <HowWeWorkPhase/>
    </>
  )
}

export default HowWeWork